/**
 * Represents a resource from the /users/ API collection.
 */

export enum UserType {
  staffMember = 'STA',
  apiIntegration = 'API',
}

export interface User {
  id: number;
  url: string;
  email: string;
  first_name: string;
  last_name: string;
  user_type: UserType;
  default_gym_id: number;
  default_gym_name: string;
  default_gym_url: string;
  date_joined: string;
  is_active: boolean;
  can_log_in_to_staff_site: boolean;
  can_manage_events: boolean;
  can_manage_members: boolean;
  can_manage_customer_proficiencies: boolean;
  can_export_customers: boolean;
  can_access_reports: boolean;
  has_griptonite_access: boolean;
  can_look_up_members_by_barcode: boolean;
  is_organization_admin: boolean;
  pin_mode_required: boolean;
  otp_enabled: boolean;
  lightspeed_user_id: string;
  lightspeed_user_username: string;
  lightspeed_user_display_name: string;
  has_password: boolean;
  has_pin: boolean;
}

/**
 * Represents the set of field filters available for the /users/ API collection.
 */
export interface UserFilters {
  default_gym_id?: number;
  is_active?: boolean;

  // General-purpose text search.
  search?: string;
}

export function getUserTypeDisplay(userType: UserType) {
  switch (userType) {
    case UserType.staffMember:
      return 'Staff Member';
    case UserType.apiIntegration:
      return 'API Integration';
    default:
      return 'Unknown';
  }
}
